const initSpicyLotusArticle = (root) => {
  const content = root.querySelector('[data-sl-article-content]');
  if (!content) return;


  const markPortraitImage = (image) => {
    if (image.naturalWidth && image.naturalHeight && image.naturalHeight > image.naturalWidth) {
      image.classList.add('sl-article__image--portrait');
    }
  };

  content.querySelectorAll('img').forEach((image) => {
    if (image.complete) markPortraitImage(image);
    else image.addEventListener('load', () => markPortraitImage(image), { once: true });
  });

  content.querySelectorAll('a[href]').forEach((link) => {
    try {
      const url = new URL(link.href, window.location.href);
      if ((url.protocol === 'http:' || url.protocol === 'https:') && url.origin !== window.location.origin) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      }
    } catch (error) {
      // Leave malformed or non-web links unchanged.
    }
  });

  const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
  if (headings.length < 2) return;

  const usedIds = new Set();
  const slugify = (value) => {
    const base = value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
    let slug = base;
    let suffix = 2;

    while (usedIds.has(slug) || document.getElementById(slug)) {
      slug = `${base}-${suffix}`;
      suffix += 1;
    }

    usedIds.add(slug);
    return slug;
  };

  headings.forEach((heading) => {
    if (!heading.id) heading.id = slugify(heading.textContent.trim());
  });

  root.querySelectorAll('[data-sl-toc-list]').forEach((list) => {
    const fragment = document.createDocumentFragment();

    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      item.className = heading.tagName === 'H3' ? 'sl-toc__subitem' : 'sl-toc__item';
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      fragment.append(item);
    });

    list.replaceChildren(fragment);
  });

  root.querySelectorAll('[data-sl-toc]').forEach((toc) => {
    toc.hidden = false;
    if (toc.tagName === 'DETAILS') toc.open = true;
  });
};

document.querySelectorAll('[data-sl-article]').forEach(initSpicyLotusArticle);
